import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  careerOpportunities,
  cdgiHighlights,
  facultyAndMentorship,
  globalCertifications,
  keyLearningAreas,
  labFacilities,
  placementCompanies,
  prePlacementTraining,
  researchAndDevelopment,
  studentLife,
} from "./constant";
import "./information_technology.css";
import { Modal } from "react-bootstrap";
import { CreateStudentEnquirey } from "../../../api/Global";
import Faq from "./Faq";

const Information_Technology = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);

  const navigate = useNavigate();
  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");
  const [mathAnswer, setMathAnswer] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");
  const [sumAnswerError, setsumAnswerError] = useState("");

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");
    setsumAnswerError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
    if (mathAnswer.toString() !== "14")
      return setsumAnswerError("Please add and put the correct value");
    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
        setMathAnswer("");
        setShow(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  const handleShowContent = () => {
    setShowMoreContent(!showMoreContent);
  };

  return (
    <div className="main-container">
      {/*  modal code [admission form] */}

      <Modal
        size="lg"
        className="asmission_enquiry"
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{
              textAlign: "center",
              width: "100%",
              color: "#007bff",
            }}
          >
            Admission Enquiry Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white p-2 p-lg-5">
            <div className="modlaPopup">
              <div className="elementor-widget-container">
                <form className="wpcf7-form">
                  <div className="form-group mb-3">
                    <label>Your Name</label>
                    <input
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      value={name}
                    />
                    {nameError && <p className="text-danger">{nameError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Your Email</label>
                    <input
                      className="form-control"
                      placeholder="Email ID"
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      value={email}
                    />
                    {emailError && <p className="text-danger">{emailError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Mobile Number</label>
                    <input
                      className="form-control"
                      placeholder="Phone"
                      onChange={(e) => setMobile(e.target.value)}
                      type="number"
                      name="mobile"
                      value={mobile}
                    />
                    {mobileError && (
                      <p className="text-danger">{mobileError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>City</label>
                    <input
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => setCity(e.target.value)}
                      type="text"
                      name="city"
                      value={city}
                    />
                    {cityError && <p className="text-danger">{cityError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Course</label>
                    <select
                      className="form-control"
                      required
                      name="course"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    >
                      <option value="">Please select Any Course</option>
                      <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                        Engineering Courses [CS, IT, AI & DS, CSIT]
                      </option>
                      <option value="B.Tech. Course [EC]">
                        Engineering Course [Electronics & Comm. Engg.]
                      </option>
                      <option value="B.Tech. Course [ME]">
                        Engineering Course [Mechanical Engineering]
                      </option>
                      <option value="B.Tech. Course [Civil Engg.]">
                        Engineering Course [Civil Engineering]
                      </option>
                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                        Pharmacy Courses [B.Pharm, D.Pharm]
                      </option>
                      <option value="Pharmacy Course[M.Pharm]">
                        Pharmacy Course [M.Pharm]
                      </option>
                      <option value="Management Courses[MBA(FT,MM,FA)]">
                        Management Courses [MBA(FT,MM,FA)]
                      </option>
                      <option value="Professional Course [BBA]">
                        Professional Courses [BBA]
                      </option>
                      <option value="Professional Course[BCA]">
                        Professional Courses [BCA]
                      </option>
                      <option value="Professional Course[B.Com]">
                        Professional Courses [B.Com]
                      </option>
                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                        Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                      </option>
                      <option value="MCA Course">MCA Course</option>
                    </select>
                    {courseError && (
                      <p className="text-danger">{courseError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>What is nine plus five?</label>
                    <input
                      className="form-control"
                      placeholder="Answer"
                      onChange={(e) => setMathAnswer(e.target.value)}
                      type="text"
                      name="mathAnswer"
                      value={mathAnswer}
                    />
                    {sumAnswerError && (
                      <p className="text-danger">{sumAnswerError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3 text-center">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={HandleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="main-top-container">
        <p>Best Information Technology Engineering College</p>

        <p className="container-description">
          Chameli Devi Group of Institutions (CDGI) stands as the
          <Link to={"/"}>
            {" "}
            <span className="text-hover-blue-underline">
              best information technology engineering college
            </span>{" "}
          </Link>
          in Central India, offering an advanced, industry-aligned B.Tech in
          Information Technology program. Affiliated with RGPV Bhopal, approved
          by AICTE, and accredited with NAAC A+, CDGI prepares students to lead
          in an ever-evolving tech-driven world. With a legacy of academic
          excellence, state-of-the-art labs, and top-tier placements, CDGI has
          become the first choice for students and parents looking for the best
          information technology program in Madhya Pradesh.
          <br />
          Our program focuses on foundational computer science knowledge,
          combined with hands-on training in modern IT tools, infrastructure,
          cybersecurity, and data technologies that are shaping the global
          economy.
        </p>
      </div>

      <div className="why-cdgi">
        <h2 className="container-title-h2">
          Why CDGI is the Best Information Technology Engineering College
        </h2>
        <p className="container-description">
          At CDGI, we believe that a strong educational experience is built on
          innovation, mentorship, and practical exposure. Here's why students
          consider CDGI as the best information technology engineering college:
        </p>
      </div>

      {showMoreContent && (
        <>
          <div className="cdgi-highlights-conatiner">
            <h3 className="container-title-h3">CDGI Highlights</h3>
            <div>
              {cdgiHighlights.map((highlight, ind) => (
                <ul>
                  <li key={ind}> {highlight}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="overview-container">
            <h3 className="container-title-h3">
              Overview of the Information Technology Department
            </h3>

            <p className="container-description">
              The Department of Information Technology at CDGI provides an
              immersive learning environment that encourages exploration,
              innovation, and problem-solving. Designed to nurture students into
              professionals, our IT program bridges theory with practice.
            </p>
          </div>

          <div className="key-learning-container">
            <p className="">Key Learning Areas</p>

            <div>
              {keyLearningAreas.map((item, ind) => (
                <ul>
                  <li key={ind}>{item}</li>
                </ul>
              ))}
            </div>
          </div>

          {/*  new craeted */}
          <div className="lab-facilities-container">
            <p>
              Lab Facilities CDGI has invested in cutting-edge infrastructure to
              ensure students receive practical exposure:
            </p>

            <div>
              {labFacilities.map((program, ind) => (
                <ul>
                  <li key={ind}>{program}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="career-container">
            <p>Career Scope in Information Technology</p>
            <p className="container-description">
              Pursuing a degree from the best information technology engineering
              college like CDGI opens doors to a wide range of IT careers, both
              in India and globally. Graduates from our B.Tech IT program are
              equipped to succeed in roles such as:
            </p>

            <div>
              {careerOpportunities.map((career) => (
                <ul>
                  <li>{career}</li>
                </ul>
              ))}
            </div>
          </div>

          <div className="placement-container">
            <h2 className="container-title-h2">
              Placement Support for Information Technology Students
            </h2>
            <p className="container-description">
              CDGI has a dedicated Training & Placement Cell that works
              year-round to enhance student employability. As the best
              information technology engineering college in Indore, we ensure
              students are corporate-ready from day one
            </p>
            <h3 className="container-title-h3">Top IT Recruiters at CDGI</h3>

            {placementCompanies.map((company, ind) => (
              <ul>
                <li key={ind}>{company}</li>
              </ul>
            ))}
            <h3
              className="container-title-h3"
              style={{
                marginTop: "30px",
              }}
            >
              Pre-Placement Training
            </h3>
            {prePlacementTraining.map((training, ind) => (
              <ul>
                <li key={ind}>{training}</li>
              </ul>
            ))}
          </div>

          <div className="faculty-and-mentorship-conatiner">
            <p>Faculty & Mentorship</p>
            <p>
              Our faculty includes PhD holders, industry professionals, and
              certified trainers who guide students in:
            </p>
            {facultyAndMentorship.map((item, ind) => (
              <ul>
                <li key={ind}>{item}</li>
              </ul>
            ))}
          </div>

          <div className="student-life-conatiner">
            <h2 className="container-title-h2">
              Student Life at CDGI's IT Department
            </h2>
            <p>
              Life at CDGI is vibrant and enriching. Students in the Information
              Technology stream enjoy access to:
            </p>

            {studentLife.map((item, ind) => (
              <ul>
                <li key={ind}>{item}</li>
              </ul>
            ))}
          </div>

          <div className="research-container">
            <p>Research & Development in IT</p>
            <p>
              Our goal is to cultivate a research mindset. As the best
              information technology engineering college, CDGI encourages
              innovation through:
            </p>

            {researchAndDevelopment.map((item, ind) => (
              <ul>
                <li key={ind}>{item}</li>
              </ul>
            ))}
          </div>

          <div className="global-certificates-container">
            <p>Global Certifications & Learning Platforms</p>
            <p>
              Students are given access to value-added certifications that boost
              employability:
            </p>

            {globalCertifications.map((certificate, ind) => {
              <ul>
                <li key={ind}>{certificate}</li>
              </ul>;
            })}
          </div>

          <div className="admission-container">
            <h4 className="container-title-h4">
              Admission Process for B.Tech in Information Technology
            </h4>
            <p className="eligibility-text">Eligibility Criteria</p>
            <p>• 10+2 with Physics, Chemistry, Mathematics</p>
            <p>• Valid score in JEE Main / State-level entrance exam</p>
          </div>
          <div className="apply-now-container">
            <h4 className="container-title-h4">Steps to Apply:</h4>
            <p>
              • Click{" "}
              <span className="text-hover-blue-underline" onClick={openModal}>
                Apply Now{" "}
              </span>
            </p>
          </div>
          <Faq />
        </>
      )}

      <div
        className="btn-container"
        style={{
          marginBottom: "100px",
        }}
      >
        <button
          style={{
            all: "unset",
            textAlign: "center",
            borderRadius: "3px",
            backgroundColor: "#004b9c",
            color: "white",
            cursor: "pointer",
            marginTop: "10px",
            marginLeft: "40px",
            padding: "0 10px",
          }}
          onClick={handleShowContent}
        >
          {showMoreContent ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default Information_Technology;
